import gql from 'graphql-tag'

const azioni = gql`
  query azioni (
    $limit: Int!,
    $offset: Int,
    $where: AzioniFilterInput,
    $orderBy: [AzioniOrderBy]
  ) {
    azioni (
      limit: $limit,
      offset: $offset,
      where: $where,
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        utenteId
        utente {
          id
          nome
        }
        clienteId
        cliente {
          id
          nome
          comune
          telefono
        }
        offertaId
        offerta {
          id
          nome
        }
        campagnaId
        campagna {
          id
          nome
        }
        tipoAzioneId
        tipoAzione {
          id
          tipo
        }
        appuntamentoAgenteId
        appuntamentoAgente {
          id
          nome
        }
        dataOra
        descrizione
        appuntamentoDaDataOra
        appuntamentoADataOra
        appuntamentoLuogo
        appuntamentoStato
        appuntamentoOrigine
        promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
        votoAgente
        flagSondaggioInviato
        nonRisposto
      }
    }
  }
`

export default azioni


// WEBPACK FOOTER //
// ./src/graphql/queries/azioni.js